import { FC } from "react";
import style from "./DeliveryNotice.module.scss";
import { CustomMessage } from "@~/product-card-components/WishlistCallToAction/utils/CustomMessage/CustomMessage";

export const DeliveryNotice: FC = () => {
  return (
    <CustomMessage
      type="information"
      dataTestId={"delivery-notice"}
      customClassName={style.deliveryNotice}
      title={content.title}
      htmlContent={
        <>
          <p>{content.subTitle}</p>
          <p>{content.line1}</p>

          {content.list && (
            <ul className={style.customDeliveryNoticeList}>
              {content.list.map((item, index) => (
                <li key={index} className={style.customDeliveryNoticeListItem}>
                  {item}
                </li>
              ))}
            </ul>
          )}
          {content.line2 && (
            <p className={style.customDeliveryNoticeText}>{content.line2}</p>
          )}
          {content.line3 && (
            <p className={style.customDeliveryNoticeText}>{content.line3}</p>
          )}
          {content.line4 && (
            <p className={style.customDeliveryNoticeText}>{content.line4}</p>
          )}
        </>
      }
    />
  );
};

const content: Content = {
  title: "Delivery of gifts",
  subTitle: "Wish lists don't store delivery addresses.",
  line1:
    "When buying from a shared wish list, you can choose the standard delivery options at checkout:",
  list: [
    "Your own delivery address",
    "The wish list owners preferred address",
    "A Click & Collect location",
  ],
  line2:
    "Ask the wish list owner for the address where they'd like items sent - you'll need to have this before checkout.",
  line3:
    "If choosing Click & Collect, you'll need to share delivery updates with the wish list owner.",
  line4: "Delivery options are selected during checkout.",
};

interface Content {
  title: string;
  subTitle: string;
  list?: Array<string>;
  line1: string;
  line2: string;
  line3?: string;
  line4?: string;
}
